import { match, P } from "ts-pattern";
function copy(descriptor, value, context) {
  return match([descriptor, value]).with([P.any, P.string], ([, v]) => context.replacementContext.fileIds.get(v) ?? v).with(
    [{ version: 1 }, { type: "makeswift-file", version: 1 }],
    ([, v]) => context.replacementContext.fileIds.get(v.id) ?? v.id
  ).otherwise(([, v]) => v);
}
export {
  copy
};
//# sourceMappingURL=image.js.map